export default __webpack_public_path__ + "static/media/description-name2.22b58c5a.png";